function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 59.68,
  y1: 67.65,
  x2: 20.35,
  y2: 45.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#0052cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 279.76,
  y1: -1616.34,
  x2: 240.42,
  y2: -1638.95,
  gradientTransform: "translate(282.83 -1616.71) rotate(180)",
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blue"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M134.47,60c-3.61,2.38-9.33,3.43-15.31,3.43-19,0-29.74-11.44-29.74-29.65,0-17.6,10.74-29.92,29.57-29.92,5.63,0,11.26,1.06,15.4,4v7.66c-4.14-2.64-8.71-4-15.4-4-13.55,0-21.65,9-21.65,22.26s8.36,22.09,22.09,22.09a32.46,32.46,0,0,0,15-3.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M140,40.48c0-13.2,7.74-22.79,20.94-22.79s20.77,9.59,20.77,22.79-7.66,23-20.77,23S140,53.68,140,40.48Zm7.39,0c0,8.36,4.14,15.93,13.55,15.93s13.38-7.57,13.38-15.93-4-15.75-13.37-15.75S147.41,32.12,147.41,40.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M227.93,62.57h-7.57V36c0-7.92-3.17-11.44-10.38-11.44-7,0-11.88,4.66-11.88,13.55V62.57h-7.57v-44h7.57v7.22a15.42,15.42,0,0,1,13.9-8.1c10.12,0,15.93,7,15.93,19.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M249,18.57h11.35v7H249v37h-7.39v-37h-7.13v-7h7.13V13.73c0-8.18,4.58-13.73,14-13.73a18.19,18.19,0,0,1,5.1.7v7a25,25,0,0,0-4.75-.44c-4.66,0-7,2.73-7,6.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M280.29,62.83c-7.22,0-11.79-3.43-11.79-11.53V.18h7.57V50.42c0,4,2.64,5.37,5.9,5.37a19.17,19.17,0,0,0,2.2-.09v6.78A16.11,16.11,0,0,1,280.29,62.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M290.58,18.57h7.57V45.14c0,7.92,3.17,11.44,10.38,11.44,7,0,11.88-4.66,11.88-13.55V18.57H328v44h-7.57V55.35a15.42,15.42,0,0,1-13.9,8.1c-10.12,0-15.93-7-15.93-19.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M360.45,63.45c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H344.44c1.06,7.48,5.9,12.32,16.28,12.32a39,39,0,0,0,13.38-2.38v7C370.48,62.74,364.94,63.45,360.45,63.45Zm-16.1-26H368.9c-.44-8.18-4.14-12.85-11.7-12.85C349.19,24.55,345.14,29.74,344.35,37.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M422.93,62.57h-7.57V36c0-7.92-3.17-11.44-10.38-11.44-7,0-11.88,4.66-11.88,13.55V62.57h-7.57v-44h7.57v7.22a15.42,15.42,0,0,1,13.9-8.1c10.12,0,15.93,7,15.93,19.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M464.56,61.42c-2.64,1.41-6.69,2-10.74,2-15.66,0-23-9.5-23-23,0-13.29,7.3-22.79,23-22.79a23.26,23.26,0,0,1,10.47,2.11v7a22.18,22.18,0,0,0-9.94-2.11c-11.44,0-16.1,7.22-16.1,15.75S443,56.23,454.52,56.23a27.8,27.8,0,0,0,10-1.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-1",
  d: "M494.21,63.45c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H478.19c1.06,7.48,5.9,12.32,16.28,12.32a39,39,0,0,0,13.38-2.38v7C504.24,62.74,498.7,63.45,494.21,63.45Zm-16.1-26h24.55c-.44-8.18-4.14-12.85-11.7-12.85C482.95,24.55,478.9,29.74,478.11,37.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-2",
  d: "M2.23,49.53c-.65,1.06-1.38,2.29-2,3.27a2,2,0,0,0,.67,2.72l13,8a2,2,0,0,0,2.77-.68c.52-.87,1.19-2,1.92-3.21,5.15-8.5,10.33-7.46,19.67-3l12.89,6.13a2,2,0,0,0,2.69-1l6.19-14a2,2,0,0,0-1-2.62c-2.72-1.28-8.13-3.83-13-6.18C28.51,30.45,13.62,31,2.23,49.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mono cls-3",
  d: "M60.52,17.76c.65-1.06,1.38-2.29,2-3.27a2,2,0,0,0-.67-2.72l-13-8A2,2,0,0,0,46,4.43c-.52.87-1.19,2-1.92,3.21-5.15,8.5-10.33,7.46-19.67,3L11.56,4.54a2,2,0,0,0-2.69,1l-6.19,14a2,2,0,0,0,1,2.62c2.72,1.28,8.13,3.83,13,6.18C34.24,36.84,49.13,36.27,60.52,17.76Z"
})));

var SvgConfluence = function SvgConfluence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109px",
    height: "14px",
    viewBox: "0 0 510.31 63.83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfluence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confluence.d2854897.svg";
export { ForwardRef as ReactComponent };